__turbopack_context__.v({
  "checkbox": "styles-module-scss-module__9Iihnq__checkbox",
  "checkbox_label": "styles-module-scss-module__9Iihnq__checkbox_label",
  "contains_checkbox_with_icon": "styles-module-scss-module__9Iihnq__contains_checkbox_with_icon",
  "has_icon": "styles-module-scss-module__9Iihnq__has_icon",
  "header": "styles-module-scss-module__9Iihnq__header",
  "is_checked": "styles-module-scss-module__9Iihnq__is_checked",
  "layout_flex_row": "styles-module-scss-module__9Iihnq__layout_flex_row",
  "layout_is_half": "styles-module-scss-module__9Iihnq__layout_is_half",
  "layout_is_third": "styles-module-scss-module__9Iihnq__layout_is_third",
});
